import {validURl} from '@/utils/utils.js'
import store from '../store'

const getSubDomain = (url) => {
  const currentList = url.split('.')
  const currentSubDomain = currentList[currentList.length - 2]
  return currentSubDomain
}

const generateDomain = async (url) => {
  if (url && url !== 'localhost') { 
    try {
      const { data } =  await store.dispatch('getWhiteList')
      const domains =  data?.infos.filter(item =>  {
        const currentSubDomain = getSubDomain(url)
        const currentUrl = validURl(item.domain_name) && new URL(item.domain_name)
        if (currentSubDomain.indexOf('gotin') > -1) {
          return true
        }
        return currentUrl.hostname === url
      })
      return domains.length > 0
    } catch (error) {
      return false
    }
  } else {
    return true
  }
}

// 校验url合法性并处理检查白名单
const isUnderWhiteList = async (url) =>  {
  const currentUrl = validURl(url) && new URL(url)
  return await generateDomain(currentUrl.hostname)
} 


export {
  isUnderWhiteList
}